"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = new /** @class */ (function () {
    function UrlHelper() {
    }
    UrlHelper.prototype.urlify = function (a) {
        return a.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '-').replace(/^-+|-+$/g, '');
    };
    /**
     *
     * @param url
     * @returns last segment in a url without slashes
     */
    UrlHelper.prototype.getLastSegmentInURL = function (url) {
        if (url == null) {
            return 'Empty url';
        }
        url = url.replace(/^\/|\/$/g, '');
        return url.substring(url.lastIndexOf('/') + 1);
    };
    return UrlHelper;
}());
